import { Check } from "lucide-react";

// 1–5 choices using the item's OWN scale anchors (never a global default).
// The "Tidak yakin / belum terpikirkan" escape is rendered ONLY when the item
// config allows it (allowUnsure). Large tap targets; orange = selected state.
export const ChoiceScale = ({ value, onChange, anchors, allowUnsure = true, testPrefix = "", unsureLabel = "Tidak yakin / belum terpikirkan" }) => {
  const opts = [1, 2, 3, 4, 5];
  const labels = anchors || {};
  return (
    <div>
      <div className="flex flex-col gap-2.5" role="radiogroup" aria-label="Skala 1 sampai 5">
        {opts.map((n) => {
          const active = value === n;
          return (
            <button
              key={n}
              type="button"
              role="radio"
              aria-checked={active}
              data-testid={`${testPrefix}choice-${n}`}
              onClick={() => onChange(n)}
              className="group flex items-center gap-4 w-full text-left rounded-comiq border bg-comiq-surface-alt px-4 py-4 min-h-[60px] transition-all duration-200"
              style={{
                borderColor: active ? "#F2541B" : "#E4DCCB",
                background: active ? "rgba(242,84,27,0.06)" : "#FFFFFF",
                boxShadow: active ? "0 0 0 1px #F2541B inset" : "none",
              }}
            >
              <span
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-base font-bold transition-colors"
                style={{
                  background: active ? "#F2541B" : "#F5F1E8",
                  color: active ? "#fff" : "#6A6256",
                }}
              >
                {active ? <Check size={18} strokeWidth={3} /> : n}
              </span>
              <span className="flex-1 text-[0.98rem]" style={{ color: "#17140F" }}>
                {labels[n] || labels[String(n)] || `Pilihan ${n}`}
              </span>
            </button>
          );
        })}
      </div>

      {allowUnsure && (
        <>
          {/* Visually separated escape option — only when item config allows it */}
          <div className="my-4 flex items-center gap-3" aria-hidden="true">
            <span className="h-px flex-1" style={{ background: "#E4DCCB" }} />
            <span className="text-xs font-medium" style={{ color: "#6A6256" }}>atau</span>
            <span className="h-px flex-1" style={{ background: "#E4DCCB" }} />
          </div>

          <button
            type="button"
            role="radio"
            aria-checked={value === "unsure"}
            data-testid={`${testPrefix}choice-unsure`}
            onClick={() => onChange("unsure")}
            className="flex w-full items-center gap-3 rounded-comiq border-2 border-dashed px-4 py-3.5 min-h-[56px] text-left transition-all duration-200"
            style={{
              borderColor: value === "unsure" ? "#6A6256" : "#D8CFBB",
              background: value === "unsure" ? "#EEEAE0" : "transparent",
            }}
          >
            <span
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm"
              style={{ background: "#EEEAE0", color: "#57534E" }}
            >
              ?
            </span>
            <span className="text-[0.95rem]" style={{ color: "#57534E" }}>
              {unsureLabel}
            </span>
          </button>
        </>
      )}
    </div>
  );
};
